// const $ = require('jquery/dist/jquery.js');

// window.jQuery = $;
// window.$ = $;

const LazyLoadTempInstance = require('vanilla-lazyload/dist/lazyload.min.js');

CCL.lazyLoadInstance = new LazyLoadTempInstance();

require('bootstrap/dist/js/bootstrap.min.js');
require('promise/polyfill.js');
require('whatwg-fetch/dist/fetch.umd');
require('owl.carousel.custom/dist/owl.carousel.js');
require('lightslider/dist/js/lightslider.js');
require('simplebar/dist/simplebar.min.js');
require('./_autoload.js');
require('./query-params.js');
require('./rating.js');
require('./carousel.js');
require('./owlCarouselNVDA.js');
require('./login.js');
require('./add-to-cart.js');
require('./remove-from-cart.js');
require('./utils.js');
require('./htmlHelpers.js');
require('./generalFunctions');
require('./mainHeader.js');
require('../app/components/c-video-player/video-player.js');
require('../app/components/c-upsell-product-modal/upsell-product.js');
require('../app/components/c-products-faq/faq-slider.js');
require('../app/components/c-category-carousel/category-carousel.js');
require('../app/components/c-beverage-table/beverage-table.js');
require('../app/components/c-category-facets/category-facets.js');
require('../app/components/c-cart-card/cart-card.js');
require('../app/components/c-pdp-card/pdp-card.js');
require('../app/components/c-image-gallery/image-gallery.js');
require('../app/components/c-main-nav/main-nav.js');
require('../app/components/c-sorting-category/sorting-category.js');
require('../app/components/c-facet-card/facet-card.js');
require('../app/components/c-recipient-info-form/recipient-info-form.js');
require('../app/components/c-product-details/product-details.js');
require('../app/components/c-checkout-payment-card/checkout-payment-card.js');
require('../app/components/c-gift-card/gift-card.js');
require('../app/components/c-gift-link-modal/gift-link-modal.js');
require('../app/components/c-removal-cart-modal/removal-cart-modal.js');
require('../app/components/c-cheers-atc-modal/cheers-atc-modal.js');
require('../app/components/c-cheers-conflict-modal/cheers-conflict-modal.js');
require('../app/components/c-product-unavailable-modal/product-unavailable-modal.js');
require('../app/components/c-enhanced-lookup-modal/enhanced-lookup-modal.js');
require('../app/components/c-order-summary/order-summary.js');
require('../app/components/c-checkout-conflict-modal/checkout-conflict-modal.js');
require('../app/components/c-order-confirmation/order-confirmation.js');
require('../app/components/c-top-nav/top-nav.js');
require('../app/components/c-lookup-loggedin-guest-modal/lookup-loggedin-guest-modal.js');
require('../app/components/c-edit-guest-time-shorex-cart/edit-guest-time-cart.js');
require('../app/components/c-cruise-manager/cruise-manager.js');
require('../app/components/c-alert-banner-courtesy-hold-notification/alert-banner-courtesy-hold-notification.js');
require('../app/components/c-alert-banner-cut-off-notification/alert-banner-cut-off-notification.js');
require('../app/components/c-pdp-faster-to-fun/pdp-faster-to-fun.js');
require('../app/components/c-organizer-access-modal/organizer-access-modal.js');
require('../app/components/c-pdp-airport-transfers/pdp-airport-transfers.js');
require('../app/components/c-48-hour-promotion/c-48-hour-promotion.js');
require('../app/components/c-multiple-sailing-modal/multiple-sailing-modal.js');
require('../app/components/c-multiple-sailing-extended-modal/multiple-sailing-extended-modal.js');
require('../app/components/c-booking-buddy-modal/booking-buddy-modal.js');
require('../app/components/c-edit-guest-airport-transfers/edit-guest-airport-transfers.js');
require('../app/components/c-transfers-conflict-modal/transfers-conflict-modal.js');
require('../app/components/c-checkout-odg-sailing-nonsailing/checkout-odg-sailing-nonsailing.js');
require('../app/components/c-booking-buddy/booking-buddy.js');
require('../app/components/c-bgo-footer/bgo-footer.js');
require('../app/components/c-pdp-special-occassions-decors/pdp-special-occassions-decors.js');
require('../app/components/c-pdp-special-occassions-decors/pdp-fs-package.js');
require('../app/components/c-tc-modal/c-tc-modal.js');
require('../app/components/c-pdp-dining/pdp-dining.js');
require('../app/components/c-clp-atc-modal/clp-atc-modal.js');
require('../app/components/c-alcohol-atc-modal/alcohol-atc-modal.js');
require('../app/components/c-hero-banner-cruise-manager/c-hero-banner-cruise-manager.js');
require('../app/components/c-cart-edit-stateroom/cart-edit-stateroom.js');
require('../app/components/c-dining-atc-modal/dining-atc-modal.js');
require('../app/components/c-add-to-cart-modal/add-to-cart-modal.js');
require('../app/components/c-add-to-cart-success-modal/add-to-cart-success-modal.js');
require('../app/components/c-pdp-fly-to-fun/pdp-fly-to-fun.js');
require('../app/components/c-ajax-clp/c-ajax-clp.js');
require('./save-for-later.js');
require('../app/components/c-fbt/c-fbt.js');
require('../app/components/c-pdp-dining/pdp-xdining.js');
require('../app/components/c-xdining-atc-modal/xdining-atc-modal.js');
require('../app/components/c-favorites/c-favorites.js');




// WEBPACK FOOTER //
// ./src/js/index.js